const LinkedAccounts = () => {
  return (
    <div>
      <p>Manage your linked accounts here.</p>
      <p>Fields for linking accounts...</p>
    </div>
  )
}

export default LinkedAccounts
